type Handler<T = unknown> = (payload: T) => void;

export class EventBus {
  private map = new Map<string, Set<Handler>>();

  on<T = unknown>(event: string, fn: Handler<T>): () => void {
    if (!this.map.has(event)) this.map.set(event, new Set());
    this.map.get(event)!.add(fn as Handler);
    return () => this.off(event, fn as Handler);
  }

  off(event: string, fn: Handler): void {
    this.map.get(event)?.delete(fn);
  }

  emit<T = unknown>(event: string, payload?: T): void {
    const set = this.map.get(event);
    if (!set) return;
    for (const fn of [...set]) {
      try {
        fn(payload as T);
      } catch (err) {
        console.error(`[EventBus] ${event}`, err);
      }
    }
  }

  clear(): void {
    this.map.clear();
  }
}

export const bus = new EventBus();

export const Events = {
  SupplyChanged: 'supply',
  IntegrityChanged: 'integrity',
  WaveStart: 'wave:start',
  WaveClear: 'wave:clear',
  EnemyKilled: 'enemy:killed',
  EnemySpawned: 'enemy:spawned',
  EnemyBreached: 'enemy:breached',
  TowerBuilt: 'tower:built',
  TowerUpgraded: 'tower:upgraded',
  TowerSold: 'tower:sold',
  TowerSelected: 'tower:selected',
  AbilityUsed: 'ability:used',
  AbilityReady: 'ability:ready',
  Message: 'message',
  Shake: 'shake',
  ScoreChanged: 'score',
  Victory: 'victory',
  Defeat: 'defeat',
  BossPhase: 'boss:phase',
  SpecialReady: 'special:ready',
} as const;
